const state = {
    isShow: false,
}

const getters = {}

const mutations = {
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
}

const actions = {
    show({ commit }) {
        commit('setIsShow', true)
    },
    close({ commit }) {
        commit('setIsShow', false)
    },
    hide({ commit }) {
        commit('setIsShow', false)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
